import { render, staticRenderFns } from "./dashboard-grid.vue?vue&type=template&id=72c45822"
import script from "./dashboard-grid.vue?vue&type=script&lang=ts"
export * from "./dashboard-grid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports